import { useFragment } from '../../hooks/useFragment';
import { AudioFragmentMedia } from './audio/AudioFragmentMedia';
import { FragmentMediaLoading } from './FragmentMediaLoading';
import { VideoFragmentMedia } from './video/VideoFragmentMedia';

/**
 * Renders the fragment media player or a progress skeleton while media is still processing.
 */
export function FragmentMedia() {
  const { fragment } = useFragment();
  const isVideo = fragment.mediaType === 'VIDEO';

  if (!fragment.mediaCompletedAt) {
    return <FragmentMediaLoading />;
  }

  return isVideo ? <VideoFragmentMedia /> : <AudioFragmentMedia />;
}
